import { Button, Container, Row, Table, Col } from "react-bootstrap"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../stores/hooks"
import { getVideosDetailAsync, VideosState } from "../VideosSlice"
import { Field, Formik } from "formik"
import { VideosDetailInterface } from "../models/VideosDetailInterface"
import ModuleConfig from "../config/ModuleConfig"
import FormField from "../../common/FormField"
import { useEffect, useState } from "react"
import { createVideos, updateVideos } from "../VideosAPI"
import Config from "../../../utils/config"
import { appState } from "../../../stores/appSlice"
import { useAlert } from "react-alert"
import Vimeo from "@u-wave/react-vimeo"

/**
 * Videosing Favourites list page
 */
const VideosCreate = () => {
  const dispatch = useAppDispatch()
  const { status, detail } = useAppSelector(VideosState)
  const { languages } = useAppSelector(appState)
  const params = useParams()
  const navigator = useNavigate()
  const [file, setFile] = useState("")
  const alert = useAlert()

  useEffect(() => {
    if (params.video_id) {
      dispatch(getVideosDetailAsync(params.video_id))
    }
  }, [params.video_id])

  useEffect(() => {
    setFile(detail.video_blob)
  }, [detail])

  const handleSubmit = async (
    values: VideosDetailInterface,
    formMethod: any
  ) => {
    if (params.video_id) {
      let postData = { ...values }
      delete postData.Sport
      delete postData.Language

      const res: any = await updateVideos(params.video_id, postData)
      if (res.errors && res.message) {
        const errors: any = {}
        const errorKeys = Object.keys(res.errors)
        for (var i = 0; i < errorKeys.length; i++) {
          errors[errorKeys[i]] = res.errors[errorKeys[i]][0]
        }
        formMethod.setErrors(errors)
      } else if (res.statusCode >= 300) {
        alert.error(res.message)
      } else {
        dispatch(getVideosDetailAsync(params.video_id))
        alert.success("Video Details Update Successfully")
        navigator("/videos")
      }
    } else {
      let postData = { ...values, video_blob: file }
      delete postData.Sport
      delete postData.Language

      const res: any = await createVideos(postData)
      if (res.errors && res.message) {
        const errors: any = {}
        const errorKeys = Object.keys(res.errors)
        for (var i = 0; i < errorKeys.length; i++) {
          errors[errorKeys[i]] = res.errors[errorKeys[i]][0]
        }
        formMethod.setErrors(errors)
      } else {
        if (res?.statusCode == 201 || res?.statusCode == 200) {
          alert.success("Video Added Successfully")
        }
        navigator("/videos")
      }
    }
  }

  const showVideo = () => {
    return (
      <div className="col-12 h-100 w-100">
        <Vimeo video={detail.video_link} width={640} height={480} autoplay />
      </div>
    )
  }

  const sportDetails = () => {
    return (
      <>
        <span>
          <img
            className="rounded-circle rounded-circle-border"
            height="50"
            width="50"
            src={`${Config.cdnUrl}${detail?.Sport?.logo}`}
          />{" "}
          {detail?.Sport?.sport_name?.en}{" "}
        </span>
      </>
    )
  }

  return (
    <>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="page-header-title">
                <h5 className="m-b-10">Video</h5>
              </div>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="feather icon-home"></i>
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/videos">Video</Link>
                </li>
                <li className="breadcrumb-item">
                  <a>{params.video_id ? "Edit " : "Add "}Video</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <Row>
                <Col>
                  <h5 className="col-md-6">
                    {params.video_id ? "Edit " : "Add "}Video
                  </h5>
                </Col>
                <Col>
                  <div className="text-end">
                    {params.video_id ? sportDetails() : null}
                  </div>
                </Col>
              </Row>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  {(params.video_id && params.video_id == detail.video_id) ||
                  !params.video_id ? (
                    <Formik
                      initialValues={
                        params.video_id &&
                        detail[ModuleConfig.primaryKey] == params.video_id
                          ? detail
                          : ModuleConfig.formDefaultValue
                      }
                      validate={(values: any) => {
                        const errors: any = {}
                        const fields = Object.keys(ModuleConfig.formFields)
                        for (let index = 0; index < fields.length; index++) {
                          if (
                            !values[fields[index]] &&
                            ModuleConfig.formFields[fields[index]].isRequired
                          ) {
                            errors[fields[index]] = "Required"
                          }
                        }
                        if (!params.video_id && file == undefined) {
                          errors.video_blob = "Required"
                        }

                        return errors
                      }}
                      enableReinitialize={true}
                      onSubmit={handleSubmit}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            {Object.keys(ModuleConfig.formFields).map(
                              (field: string, index: number) => {
                                const fieldDetails =
                                  ModuleConfig.formFields[field]
                                return (fieldDetails.isAdd == false &&
                                  params.video_id) ||
                                  fieldDetails.isAdd == undefined ? (
                                  <div
                                    key={`field_${index}`}
                                    className={fieldDetails.colWidth}
                                  >
                                    <FormField
                                      name={field}
                                      fieldDetails={fieldDetails}
                                      values={values}
                                      errors={errors}
                                      touched={touched}
                                      maxLength={fieldDetails.maxLength}
                                      disabled={
                                        (Config?.enLanguageID ==
                                          values?.language_id ||
                                          "" == values?.language_id) &&
                                        fieldDetails.disabled
                                      }
                                      setFieldValue={setFieldValue}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                    />
                                  </div>
                                ) : null
                              }
                            )}
                            {!params.video_id && (
                              <div className={"col-md-6"}>
                                <label>Video</label>
                                <Field
                                  name="json_blob"
                                  className="form-control"
                                  type="file"
                                  accept="video/*"
                                  onChange={(event: any) => {
                                    if (event.target.files[0]) {
                                      setFile(event.target.files[0])
                                    }
                                  }}
                                />
                                {errors.video_blob ? (
                                  <p className="text-danger">Required</p>
                                ) : null}
                              </div>
                            )}
                          </div>
                          <hr />
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </form>
                      )}
                    </Formik>
                  ) : null}
                </div>
                {params.video_id && detail.video_id && showVideo()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default VideosCreate
